import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form-html5-validation';
import * as actions from '../../../actions';
import { 
    conditionallyRequiredSignature,
    conditionallyRequiredSignatureDate,
    conditionallyRequiredText
} from '../../helpers/Validation';
import SignatureCanvas from 'react-signature-canvas';
import { textField } from '../../helpers/Form';
import SignatureDate from '../../hooks/SignatureDate';

class Step5Form extends Component {
    constructor(props) {
        super(props)
        this.state = {
            residentSignature: null,
            submitted: false,
            residentSignatureDate: null
        }
    }

    // Used to restore sigs
    componentDidMount() {
        const { residentSignature } = this.props.questionOptions; 

        const options = {
            minWidth: 0.5,
        }
        if (residentSignature) {
            this[("residentSignatureRef")].fromDataURL(residentSignature, options);
        }
    }

    clearSigCanvas = (refName) => {
        this[(refName + "Ref")].clear();
    }

    storeSigData = (refName) => {
        this.setState({
            ...this.state,
            [refName]: this[(refName + "Ref")].getTrimmedCanvas().toDataURL()
        })
        this.props.questionAnswer(refName, this[(refName + "Ref")].toDataURL());
    };
      
    render() {
        const { currentStep } = this.props;
        const { residentSignature } = this.state;
        const {
            authorizedRepresentative,
            authorizedRepresentativeTwo,
            relationshipToPatient,
            relationshipToPatientTwo,
            residentSignatureDate
        } = this.props.questionOptions;

        return (
            <Fragment>
                <div className="row mobile-step-header">
                    <div className="col-sm-2 col-2">
                        <span className="header-number">{currentStep}</span>
                    </div>
                    <div className="col-sm-10 col-10 pl-0">
                        <h3 className="euclid">AUTHORIZATION &#38; SUBMISSION</h3>
                        <div className="d-inline-block">*<i class="required-field-indication"> Indicates required field.</i></div>
                        
                    </div>
                    <div class="row grey-spacer-col-1"></div>
                </div>

                <div className="spacer-medium">&nbsp;</div>
                <div className="row mobile-step-header">
                    <div className="col">
                        <h3 className="euclid">AUTHORIZATION TO DISCLOSE INFORMATION TO INDIVIDUALS INVOLVED IN MY CARE (optional)</h3>
                        <p style={{paddingTop: '5px'}}>I further authorize Acadia Pharmaceuticals Inc. to discuss the coordination of my care with the following family member(s) and/or caregiver(s):</p>
                    </div>
                </div>
                <div className="row spacer-medium">&nbsp;</div>

                <div className="row">
                    <div className="col-sm">
                        <Field
                            name="authorizedRepresentative"
                            label={"Authorized representative (1) name " + (authorizedRepresentative || relationshipToPatient ? "" : "(optional)")}
                            placeholder={"Authorized representative (1) name " + (authorizedRepresentative || relationshipToPatient ? "" : "(optional)")}
                            component={textField}
                            validate={conditionallyRequiredText(authorizedRepresentative || relationshipToPatient ? 1 : 0)}
                            key={authorizedRepresentative || relationshipToPatient ? 1 : 0}
                            onBlur={(event) => this.props.questionAnswer("authorizedRepresentative", event)}
                            customMobileTop="-15px"
                            customMobileLabelTop="-44px"
                        />
                    </div>
                    <div className="col-sm">
                        <Field
                            name="relationshipToPatient"
                            label={"Relationship to patient " + (authorizedRepresentative || relationshipToPatient ? "" : "(optional)")}
                            placeholder={"Relationship to patient " + (authorizedRepresentative || relationshipToPatient ? "" : "(optional)")}
                            component={textField}
                            validate={conditionallyRequiredText(authorizedRepresentative || relationshipToPatient ? 1 : 0)}
                            key={authorizedRepresentative || relationshipToPatient ? 1 : 0}
                            onBlur={(event) => this.props.questionAnswer("authorizedRepresentativeRelationship", event)}  
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm">
                        <Field
                            name="authorizedRepresentativeTwo"
                            label={"Authorized representative (2) name " + (authorizedRepresentativeTwo || relationshipToPatientTwo ? "" : "(optional)")}
                            placeholder={"Authorized representative (1) name " + (authorizedRepresentativeTwo || relationshipToPatientTwo ? "" : "(optional)")}
                            component={textField}
                            validate={conditionallyRequiredText(authorizedRepresentativeTwo || relationshipToPatientTwo ? 1 : 0)}
                            key={authorizedRepresentativeTwo || relationshipToPatientTwo ? 1 : 0}
                            onBlur={(event) => this.props.questionAnswer("authorizedRepresentativeTwo", event)}
                            customMobileTop="-15px"
                            customMobileLabelTop="-44px"
                        />
                    </div>
                    <div className="col-sm">
                        <Field
                            name="relationshipToPatientTwo"
                            label={"Relationship to patient " + (authorizedRepresentativeTwo || relationshipToPatientTwo ? "" : "(optional)")}
                            placeholder={"Relationship to patient " + (authorizedRepresentativeTwo || relationshipToPatientTwo ? "" : "(optional)")}
                            component={textField}
                            validate={conditionallyRequiredText(authorizedRepresentativeTwo || relationshipToPatientTwo ? 1 : 0)}
                            key={authorizedRepresentativeTwo || relationshipToPatientTwo ? 1 : 0}
                            onBlur={(event) => this.props.questionAnswer("relationshipToPatientTwo", event)}  
                        />
                    </div>
                </div>
                <div className="hipaa">
                    <Field
                        name="residentSignature"
                        defaultValue={residentSignature}
                        component="input"
                        key={(residentSignature || residentSignatureDate) ? 1 : 0}
                        validate={conditionallyRequiredSignature((residentSignature || residentSignatureDate) ? 1 : 0)}
                    >
                        {({ input, meta }) => (
                            <Fragment>
                                <label style={{marginBottom: '5px'}} className={meta.error && meta.touched ? "fancy-label signature-error" : "fancy-label"} htmlFor="residentSignature">Resident/Legal guardian signature</label> 
                            </Fragment>
                        )}
                    </Field>
                    <div className="text-center relative form-group"> 
                        <SignatureCanvas
                         penColor='black' 
                         canvasProps={{height: 200, className: 'sig-canvas'}} 
                         onEnd={() => this.storeSigData("residentSignature")} 
                         ref={(ref) => { this.residentSignatureRef = ref }} 
                         clearOnResize={false} 
                         />
                        <button type="button" className="canvas-clear" onClick={() => this.clearSigCanvas("residentSignature")}>CLEAR</button>
                        <Field
                            name="residentSignature"
                            defaultValue={residentSignature}
                            component="input"
                            key={(residentSignature || residentSignatureDate) ? 1 : 0}
                            validate={conditionallyRequiredSignature((residentSignature || residentSignatureDate) ? 1 : 0)}
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                    {meta.error && meta.touched && meta.error }
                                </Fragment>
                            )}
                        </Field>
                    </div>
                    <SignatureDate forDate="prescriberAgentSignature"/>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    const { currentStep, questionOptions } = state;
    return { currentStep: currentStep, questionOptions: questionOptions };
}
  
export default connect(mapStateToProps, actions)(Step5Form);